import './App.css';
import Approutes from './Routes/Approutes';
import { ToastContainer } from 'react-toastify';
import GlobalLoader from './global/config/Action/GlobalLoader';
import DownloadApp from './Screens/DownloadApp/DownloadApp';


function App() {

  const isMobile = /Android|iPhone|iPad|iPod/i.test(
    navigator.userAgent
  );

  if (isMobile) {
    return <DownloadApp />;
  }

  return (
    <div className="App">
      <ToastContainer />
      <GlobalLoader />
      <Approutes />
    </div>
  );
}

export default App;
